import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, onUnmounted } from 'vue';
import { ChevronUp } from 'lucide-vue-next';

const THRESHOLD = 400;

export default /*@__PURE__*/_defineComponent({
  __name: 'ScrollToTopButton',
  setup(__props) {

const visible = ref(false);

function onScroll() {
  visible.value = window.scrollY > THRESHOLD;
}

function scrollTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

onMounted(() => {
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
});

onUnmounted(() => {
  window.removeEventListener('scroll', onScroll);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    "aria-label": "Tillbaka till toppen",
    class: _normalizeClass(["fixed bottom-6 left-6 z-40 flex h-10 w-10 items-center justify-center rounded-full border border-border bg-background p-0 text-foreground shadow-md transition-all duration-300 hover:bg-accent", visible.value ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-4 opacity-0']),
    onClick: scrollTop
  }, [
    _createVNode(_unref(ChevronUp), { class: "h-5 w-5" })
  ], 2))
}
}

})